export default class ResetFilters {
  static initAll(): void {
    $('.js-resetFilters')
      .on('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.delete('stockLevel');
        params.delete('tireLoadIndex');
        params.delete('tireSpeedIndex');
        params.delete('tireConsumption');
        params.delete('tireQuickSearch');

        const vehicleCode = params.get('searchedVehicleCode');
        const defaultQuery = vehicleCode ? `:productPopularitySort-desc:vehicleCode:${vehicleCode}` : ':productPopularitySort-desc';
        params.set('q', defaultQuery);
        params.set('pageSize', '20');

        window.location.href = `${window.location.href.split('?')[0]}?${params.toString()}`;
      });
  }
}
